import axios from "axios";
import { configData } from "../config/config.js";
import { codeHelper } from "./responseCode";
import Vue from "vue";
import router from "../router/index";


const JSONbig = require('json-bigint')({ 'storeAsString': true });
async function getAjax(url, data) {
  let headers = {
    "Content-Type": "application/json",
    agent: configData.agentKey,
    domain: configData.domain,
    // authorizedKey: configData.authorizedKey
  };

  return axios
    .post(url, data, {
      headers: headers,
      transformResponse: ((data) => {
        return JSONbig.parse(data);
      })
    }).then(res => {
      // console.log(res)
      if (res.data.statusCode !== 200) {

        let codeData = codeHelper.find(obj => {
          return obj.statusCode == res.data.statusCode;
        });
        try {
          alert(codeData.cn + "(" + codeData.statusCode + ")");
        } catch (ex) {

          alert("errorCode = (" + res.data.statusCode + ")");
        }

      }
      return Promise.resolve(res);
    })
    .catch(ex => {
      console.log(ex);
      console.log("error");
    });
}

async function getAjaxIgnoreErr(url, data) {
  let headers = {
    "Content-Type": "application/json",
    agent: configData.agentKey,
    domain: configData.domain,
    // authorizedKey: configData.authorizedKey
  };

  return axios
    .post(url, data, {
      headers: headers,
      transformResponse: ((data) => {
        return JSONbig.parse(data);
      })
    }).then(res => {
      // console.log(res)

      return Promise.resolve(res);
    })
    .catch(ex => {
      console.log(ex);
      console.log("error");
    });
}

async function getAjaxNoAlert(url, data) {
  let headers = {
    "Content-Type": "application/json",
    agent: configData.agentKey,
    domain: configData.domain,
    // authorizedKey: configData.authorizedKey
  };

  return axios
    .post(url, data, {
      headers: headers,
      transformResponse: ((data) => {
        return JSONbig.parse(data);
      })
    }).then(res => {
      // console.log(res)
      return Promise.resolve(res);
    });
}

function getGetAjax(url) {
  let headers = {
    // "Content-Type": "application/json",
    agent: configData.agentKey,
    domain: configData.domain,
    // authorizedKey: configData.authorizedKey
  };
  return axios
    .get(url, {
      headers: headers,
      transformResponse: ((data) => {
        return JSONbig.parse(data);
      })
    }).then(res => {
      if (res.data.statusCode !== 200) {

      }
      return Promise.resolve(res);
    })
    .catch(ex => {
      console.log(ex);
      console.log("error");
    });
}

function getListAjax(url) {
  let headers = {
    language: configData.currentLang
  };
  return axios
    .get(url, {
      headers:headers,
      transformResponse: ((data) => {
        return JSONbig.parse(data);
      })
    }).then(res => {
      if (res.data.statusCode !== 200) {

      }
      return Promise.resolve(res);
    })
    .catch(ex => {
      console.log(ex);
      console.log("error");
    });
}


var gameapiService = {
  playGame: function (data) {
    let url = configData.gameAPI + "playgame";

    // let content = "ID = " + data.playerID + " , Game" + data.gameCode
    // document.write()

    let ajax = getAjax(url, data);
    return ajax;
  },
  outerWalletPlayGame: function (data) {
    let url = "http://192.168.5.64:8080/jdb/playgame";

    // let content = "ID = " + data.playerID + " , Game" + data.gameCode
    // document.write()

    let ajax = getAjax(url, data);
    return ajax;
  },
  checkTransfer: function (data) {
    let url = configData.gameAPI + "checktransfer";
    let ajax = getAjax(url, data);
    return ajax;
  },
  createPlayer: function (data) {
    let url = configData.gameAPI + "createplayer";
    let ajax = getAjaxIgnoreErr(url, data);
    return ajax;
  },
  kickPlayer: function (data) {
    let url = configData.gameAPI + "kickplayer";
    let ajax = getAjax(url, data);
    return ajax;
  },
  trialPlayGame: function (data) {
    let url = configData.gameAPI + "trialplaygame";
    let ajax = getAjax(url, data);
    return ajax;
  },
  queryPoint: function (data) {
    let url = configData.gameAPI + "querypoint";
    let ajax = getAjax(url, data);
    return ajax;
  },
  deposit: async function (data) {
    let url = configData.gameAPI + "deposit";
    let ajax = getAjax(url, data);
    return ajax;
  },
  withdrawal:async function (data) {
    let url = configData.gameAPI + "withdrawal";
    let ajax = getAjaxNoAlert(url, data);
    return ajax;
  },
  lockPlayer: function (data) {
    let url = configData.gameAPI + "lockplayer";
    let ajax = getAjax(url, data);
    return ajax;
  },
  unLockPlayer: function (data) {
    let url = configData.gameAPI + "unlockplayer";
    let ajax = getAjax(url, data);
    return ajax;
  },
  gameList: function (data) {
    let url = configData.serviceAPI + "gamelist";
    let ajax = getGetAjax(url);
    return ajax;
  },
  gameListPost: function (data) {
    let url = configData.serviceAPI + "gamelist";
    let ajax = getAjax(url,data);
    return ajax;
  },
  gameRecordByTime: function (data) {
    let url = configData.serviceAPI + "gamerecordbytime";
    let ajax = getAjax(url, data);
    return ajax;
  },
  tradeRecordByTime: function (data) {
    let url = configData.serviceAPI + "traderecordbytime";
    let ajax = getAjax(url, data);
    return ajax;
  },
  queryplayerstatus: function (data) {
    let url = configData.gameAPI + "queryplayerstatus";
    let ajax = getAjax(url, data);
    return ajax;
  },

  querygamedetail: function (data) {
    let url = configData.gameAPI + "querygamedetail";
    let ajax = getAjax(url, data);
    return ajax;
  },
  playerdailyreport: function (data) {
    let url = configData.serviceAPI + "playerdailyreport";
    let ajax = getAjax(url, data);
    return ajax;
  },
  getallenablegame: function (data) {
    let url = configData.frontendAPI + "getallenablegame2";
    let ajax = getListAjax(url, data);
    return ajax;
  },
  getallenablegame3: function (data) {
    let url = configData.frontendAPI + "getallenablegame3";
    let ajax = getListAjax(url, data);
    return ajax;
  },
  getAllEnableGameSort: function (data) {
    let url = configData.frontendAPI + "getallenablegamesort";
    let ajax = getListAjax(url, data);
    return ajax;
  },
  getjackpotstatus: function (data) {
    let url = configData.serviceAPI + "jackpotstatus";
    let ajax = getGetAjax(url);
    return ajax;
  },
  getplayerspoint: function (data) {
    let url = configData.serviceAPI + "getplayerspoint";
    let ajax = getAjax(url, data);
    return ajax;
  },
  getonlineplayers: function (data) {
    let url = configData.serviceAPI + "getonlineplayers";
    let ajax = getAjax(url, data);
    return ajax;
  },
  playlobby: function (data) {
    let url = configData.gameAPI + "playlobby";
    let ajax = getAjax(url, data);
    return ajax;
  },
  eventlobby: function (data) {
    let url = configData.gameAPI + "eventlobby";
    let ajax = getAjax(url, data);
    return ajax;
  },
};

export { gameapiService };



// WEBPACK FOOTER //
// ./src/service/gameApiService.js